export default {
    watch: {
        query(now, before) {
            if (now !== before) {
                this.find(now);
            }
        },
    },
    data() {
        return {
            query: null,
            queryTimer: null,
            queryDebounceTime: 200,
            queryLengthThreshold: 2,
            typing: false,
        };
    },
    methods: {
        debouncedDelegate() {
            throw new Error('Must be implemented by the component');
        },
        resetDelegate() {
            throw new Error('Must be implemented by the component');
        },
        /**
         * Debounce a string query.
         * @param {string} query
         */
        find(query) {
            if (query === null) {
                return;
            }
            this.typing = true;
            // only trigger if we have enough characters
            if (query.trim().length >= this.queryLengthThreshold) {
                clearTimeout(this.queryTimer);
                // debounce query
                this.queryTimer = setTimeout(() => {
                    this.typing = false;
                    this.debouncedDelegate(query);
                }, this.queryDebounceTime);
            } else {
                this.resetDelegate(query);
            }
        },
    },
};
